import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Ejemplo from '../views/Ejemplo.vue'
import Socios from '../views/Socios.vue'
// import SeminarioRaya from '../views/SeminarioRaya.vue'
// import SeminarioUday from '../views/SeminarioUday.vue'
import Socio from '../views/Socio.vue'
import PanelDeControl from '../views/PanelDeControl.vue'
import EditarSocio from '../views/EditarSocio.vue'
import EditarServicio from '../views/EditarServicio.vue'
import CrearPago from '../views/CrearPago.vue'
import EditarPago from '../views/EditarPago.vue'
import ListarPagos from '../views/ListarPagos.vue'
import ServicioImpago from '../views/ServicioImpago.vue'
import ListarProductos from '../views/ListarProductos.vue'
import ListarVentasEntregadas from '../views/ListarVentasEntregadas.vue'
import ListarVentasNoEntregadas from '../views/ListarVentasNoEntregadas.vue'
import EstadisticaVentas from '../views/EstadisticaVentas.vue'
import ListarServicios from '../views/ListarServicios.vue'
import ListarAlumnosPorProfe from '../views/ListarAlumnosPorProfe.vue'
import CrearSocio from '../views/CrearSocio.vue'
import GenerarPassword from '../views/GenerarPassword.vue'
import RecuperarPassword from '../views/RecuperarPassword.vue'
import SocioNuevoPassword from '../views/SocioNuevoPassword.vue'
import Stock from '../views/Stock.vue'
import EditarStock from '../views/EditarStock.vue'
import EditarPuntoDeEntrega from '../views/EditarPuntoDeEntrega.vue'
import CrearServicio from '../views/CrearServicio.vue'
import CrearVenta from '../views/CrearVenta.vue'
import CrearMentoreado from '../views/CrearMentoreado.vue'
import Ventas from '../views/Ventas.vue'
import CargarEntrega from '../views/CargarEntrega.vue'
import MovimientoStock from '../views/MovimientoStock.vue'
import DatosPersonales from '../views/DatosPersonales.vue'
import Beneficios from '../views/Beneficios.vue'
import IncripcionExamenNivel1 from '../views/IncripcionExamenNivel1.vue'
import ExclusivoProfesores from '../views/ExclusivoProfesores.vue'
import HacermeSocio from '../views/HacermeSocio.vue'
import RespuestaPago from '../views/RespuestaPago.vue'
import Asociarse from '../views/Asociarse.vue'
import SoySocio from '../views/SoySocio.vue'
import PagoExitoso from '../views/PagoExitoso.vue'
import PagoExitosoCarrito from '../views/PagoExitosoCarrito.vue'
import PagoRechazadoCarrito from '../views/PagoRechazadoCarrito.vue'
import PagoRechazado from '../views/PagoRechazado.vue'
import PagoExitosoAsociarse from '../views/PagoExitosoAsociarse.vue'
import MercadoPagoCheck from '../views/MercadoPagoCheck.vue'
import Difusion from '../views/Difusion.vue'
import Nivel1Requisitos from '../views/Nivel1Requisitos.vue'
import GuiaEnseñanza from '../views/GuiaEnseñanza.vue'
import PuntosDeEntrega from '../views/PuntosDeEntrega.vue'
import CrearEntregaVenta from '../views/CrearEntregaVenta.vue'
import AgregarPuntoDeEntrega from '../views/AgregarPuntoDeEntrega.vue'
import SeminarioUdaySocio from '../views/SeminarioUdaySocio.vue'
import EncuentroNacional2026Socio from '../views/EncuentroNacional2026Socio.vue'
import EncuentroNacional2026NoSocio from '../views/EncuentroNacional2026NoSocio.vue'
// import SeminarioJawaharSocio from '../views/SeminarioJawaharSocio.vue'
// import SeminarioJawaharNoSocio from '../views/SeminarioJawaharNoSocio.vue'
import Convencion2025Socio from '../views/Convencion2025Socio.vue'
// import Viveka from '../views/Viveka.vue'
// import Samyoga2025Socio from '../views/Samyoga2025Socio.vue'
// import Samyoga2025NoSocio from '../views/Samyoga2025NoSocio.vue'
import Samyoga2025Estadistica from '../views/Samyoga2025Estadistica.vue'
// import Convencion2025NoSocio from '../views/Convencion2025NoSocio.vue'
import MaterialDidactico from '../views/MaterialDidactico.vue'
import MesaDeExamenNoviembre2025 from '../views/MesaDeExamenNoviembre2025.vue'
import MesaDeExamenNoviembre2026 from '../views/MesaDeExamenNoviembre2026.vue'
import MesasDeExamenes from '../views/MesasDeExamenes.vue'
import Mentorias from '../views/Mentorias.vue'
import Mentores from '../views/Mentores.vue'
import MentoriasListado from '../views/MentoriasListado.vue'
import ExamenCargado from '../views/ExamenCargado.vue'
import EditarExamen from '../views/EditarExamen.vue'
import CargarResultadoExamen from '../views/CargarResultadoExamen.vue'
import DatosInscripcionExamen from '../views/DatosInscripcionExamen.vue'
import Convencion2025Merchandising from '../views/Convencion2025Merchandising.vue'
import authService from '../services/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/ejemplo',
    name: 'Ejemplo',
    component: Ejemplo
  },
  {
    path: '/asociarse',
    name: 'Asociarse',
    component: Asociarse
  },
  {
    path: '/soy-socio',
    name: 'SoySocio',
    component: SoySocio
  },
  {
    path: '/material-didactico',
    name: 'MaterialDidactico',
    component: MaterialDidactico
  },
  {
    path: '/mesa-examen-noviembre-2025',
    name: 'MesaDeExamenNoviembre2025',
    component: MesaDeExamenNoviembre2025
  },
  {
    path: '/mesa-examen-noviembre-2026',
    name: 'MesaDeExamenNoviembre2026',
    component: MesaDeExamenNoviembre2026
  },
  {
    path: '/mesas-de-examenes',
    name: 'MesasDeExamenes',
    component: MesasDeExamenes
  },
  {
    path: '/examen-cargado/:id',
    name: 'ExamenCargado',
    component: ExamenCargado
  },
  {
    path: '/cargar-resultado-examen/:id',
    name: 'CargarResultadoExamen',
    component: CargarResultadoExamen
  },
  {
    path: '/editar-examen/:id',
    name: 'EditarExamen',
    component: EditarExamen
  },
  {
    path: '/datos-inscripcion-examen/:id',
    name: 'DatosInscripcionExamen',
    component: DatosInscripcionExamen
  },
  // {
  //   path: '/seminario-uday',
  //   name: 'SeminarioUday',
  //   component: SeminarioUday
  // },
  // {
  //   path: '/convencion-2025-no-socio',
  //   name: 'Convencion2025NoSocio',
  //   component: Convencion2025NoSocio
  // },
  // {
  //   path: '/seminario-jawahar-no-socio',
  //   name: 'SeminarioJawaharNoSocio',
  //   component: SeminarioJawaharNoSocio
  // },
  {
    path: '/respuesta-pago',
    name: 'RespuestaPago',
    component: RespuestaPago
  },
  {
    path: '/hacerme-socio',
    name: 'HacermeSocio',
    component: HacermeSocio
  },
  {
    path: '/datos-personales',
    name: 'DatosPersonales',
    component: DatosPersonales,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/beneficios',
    name: 'Beneficios',
    component: Beneficios,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mentorias',
    name: 'Mentorias',
    component: Mentorias,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mentores',
    name: 'Mentores',
    component: Mentores,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/examen-nivel-1',
    name: 'IncripcionExamenNivel1',
    component: IncripcionExamenNivel1,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/exclusivo-profesores',
    name: 'ExclusivoProfesores',
    component: ExclusivoProfesores,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/pago-exitoso',
    name: 'PagoExitoso',
    component: PagoExitoso
  },
  {
    path: '/pago-carrito-exitoso',
    name: 'PagoExitosoCarrito',
    component: PagoExitosoCarrito
  },
  {
    path: '/pago-carrito-rechazado',
    name: 'PagoRechazadoCarrito',
    component: PagoRechazadoCarrito
  },
  {
    path: '/pago-rechazado',
    name: 'PagoRechazado',
    component: PagoRechazado
  },
  {
    path: '/pago-exitoso-asociarse',
    name: 'PagoExitosoAsociarse',
    component: PagoExitosoAsociarse
  },
  // {
  //   path: '/samyoga-2025-no-socio',
  //   name: 'Samyoga2025NoSocio',
  //   component: Samyoga2025NoSocio
  // },
  {
    path: '/socios',
    name: 'Socios',
    component: Socios,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/listado-mentorias',
    name: 'MentoriasListado',
    component: MentoriasListado,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/puntos-de-entrega',
    name: 'PuntosDeEntrega',
    component: PuntosDeEntrega,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/panel-de-control',
    name: 'PanelDeControl',
    component: PanelDeControl,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/difusion',
    name: 'Difusion',
    component: Difusion,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/nivel-1-requisitos',
    name: 'Nivel1Requisitos',
    component: Nivel1Requisitos,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/guia',
    name: 'GuiaEnseñanza',
    component: GuiaEnseñanza,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/seminario-uday-socio',
    name: 'SeminarioUdaySocio',
    component: SeminarioUdaySocio,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/encuentro-2026-socio',
    name: 'EncuentroNacional2026Socio',
    component: EncuentroNacional2026Socio,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/encuentro-2026-no-socio',
    name: 'EncuentroNacional2026NoSocio',
    component: EncuentroNacional2026NoSocio
  },
  // {
  //   path: '/seminario-jawahar-socio',
  //   name: 'SeminarioJawaharSocio',
  //   component: SeminarioJawaharSocio,
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  {
    path: '/convencion-2025-socio',
    name: 'Convencion2025Socio',
    component: Convencion2025Socio,
    meta: {
      requiresAuth: true
    }
  },
  // {
  //   path: '/viveka',
  //   name: 'Viveka',
  //   component: Viveka,
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  // {
  //   path: '/samyoga-2025-socio',
  //   name: 'Samyoga2025Socio',
  //   component: Samyoga2025Socio,
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  {
    path: '/convencion2025-estadistica',
    name: 'Convencion2025Merchandising',
    component: Convencion2025Merchandising,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/samyoga2025-estadistica',
    name: 'samyoga2025Merchandising',
    component: Samyoga2025Estadistica,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cargar-entrega/:id',
    name: 'CargarEntrega',
    component: CargarEntrega,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/ventas',
    name: 'Ventas',
    component: Ventas,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/socio/:id',
    name: 'Socio',
    component: Socio,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/crear-pago',
    name: 'CrearPago',
    component: CrearPago,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/crear-servicio',
    name: 'CrearServicio',
    component: CrearServicio,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/crear-venta',
    name: 'CrearVenta',
    component: CrearVenta,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/crear-mentoreado',
    name: 'CrearMentoreado',
    component: CrearMentoreado,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/recuperar-password',
    name: 'RecuperarPassword',
    component: RecuperarPassword
  },
  {
    path: '/socio-nuevo-password',
    name: 'SocioNuevoPassword',
    component: SocioNuevoPassword
  },
  {
    path: '/generar-password/:id',
    name: 'GenerarPassword',
    component: GenerarPassword
  },
  {
    path: '/crear-socio',
    name: 'CrearSocio',
    component: CrearSocio,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/listar-pagos',
    name: 'ListarPagos',
    component: ListarPagos,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/servicio-impago',
    name: 'ServicioImpago',
    component: ServicioImpago,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/listar-productos',
    name: 'ListarProductos',
    component: ListarProductos,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/estadistica-ventas',
    name: 'EstadisticaVentas',
    component: EstadisticaVentas,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/listar-ventas-entregadas',
    name: 'ListarVentasEntregadas',
    component: ListarVentasEntregadas,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/listar-ventas-no-entregadas',
    name: 'ListarVentasNoEntregadas',
    component: ListarVentasNoEntregadas,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/listar-servicios',
    name: 'ListarServicios',
    component: ListarServicios,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/listar-alumnos-por-profe',
    name: 'ListarAlumnosPorProfe',
    component: ListarAlumnosPorProfe,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/stock',
    name: 'Stock',
    component: Stock,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/check-mercado-pago',
    name: 'MercadoPagoCheck',
    component: MercadoPagoCheck,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/movimiento-stock',
    name: 'MovimientoStock',
    component: MovimientoStock,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/editar-stock/:id',
    name: 'EditarStock',
    component: EditarStock,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/editar-punto-de-entrega/:id',
    name: 'EditarPuntoDeEntrega',
    component: EditarPuntoDeEntrega,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/editar-pago/:id',
    name: 'EditarPago',
    component: EditarPago,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/crear-entrega-venta/:id',
    name: 'CrearEntregaVenta',
    component: CrearEntregaVenta,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/agregar-punto-de-entrega',
    name: 'AgregarPuntoDeEntrega',
    component: AgregarPuntoDeEntrega,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: '/editar-socio',
    name: 'EditarSocio',
    component: EditarSocio,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/editar-servicio/:id',
    name: 'EditarServicio',
    component: EditarServicio,
    meta: {
      requiresAuth: true
    }
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  routes
})
// Registramos el navigation guard global, para poder agregar lógica de autenticación.
router.beforeEach((to, from, next) => {
  // Esto se ejecuta antes del cambio de una ruta.
  // Así que vmaos a preguntar si el usuario está autenticado al servicio de autencación, pero solo
  // si la ruta requiere que el usuario lo esté.
  // "to" contiene un objeto "ruta" con todos los datos de ella.
  // Entre sus propiedades figura "matched", que es un array de las rutas que matchean con la nueva URL.
  // De esas, vamos a verificar si al menos una requiere que el usuario esté autenticado, con ayuda
  // de la función nativa de js "some".
  if (to.matched.some(route => route.meta.requiresAuth === true)) {
    if (!authService.isLogged()) {
      // Redireccionamos al usuario al login.
      next({
        path: '/'
      })
    } else {
      // Tenemos que agregar los next() en cada else, no podemos simplemente dejarlo "decantar" al último.
      next()
    }
  } else if (to.matched.some(route => route.meta.requiresAdmin === true)) {
    if (!authService.isLogged2()) {
      // Redireccionamos al usuario al login.
      next({
        path: '/datos-personales'
      })
    } else {
      // Tenemos que agregar los next() en cada else, no podemos simplemente dejarlo "decantar" al último.
      next()
    }
  } else {
    next()
  }
})
export default router
